import React from 'react';
import { FormattedMessage } from 'react-intl';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';

const AttendeeFooter = ({ redirUserToHomepage }) => {
  const urlPrefix = SharedIntlProviderHOC.getUrlPrefix();
  return (
    <div className="AttendeeFooter style-2 flex center">
      <div className="attendeeFooterContainer flex column">
        <div className="title flex middle center margin-xl-bottom margin-lg-top">
          <h6 className="flex no-top-margin no-bottom-margin">
            <FormattedMessage id="invite.attendee_footer.space_brought" defaultMessage="Space brought to you by" />
          </h6>

          <a className="logo flex margin-xl-left" href={`/${urlPrefix}`}>
            <img src="https://assets.peerspace.com/ps_logo_dark-v2.svg" alt="peerspace" />
          </a>
        </div>

        <div className="text-center margin-xxl-bottom">
          <FormattedMessage id="invite.attendee_footer.access_collection" defaultMessage="Access a collection of unique, undiscovered locations to book for your next activity" />
        </div>

        <div className="valueProps flex flex-wrap space-between margin-xxl-bottom">
          <div className="valuePropContainer flex middle">
            <div className="svgContainer flex center">
              <img src="/web-2/assets/images/purple-location.svg?v=rb" alt="peerspace" />
            </div>

            <span>
              <FormattedMessage id="invite.attendee_footer.browse" defaultMessage="Browse homes, lofts, galleries, and more" />
            </span>
          </div>

          <div className="valuePropContainer flex middle">
            <div className="svgContainer flex center">
              <img src="/web-2/assets/images/purple-chat.svg?v=rb" alt="peerspace" />
            </div>

            <span>
              <FormattedMessage id="invite.attendee_footer.compare" defaultMessage="Compare prices and connect with hosts" />
            </span>
          </div>

          <div className="valuePropContainer flex middle">
            <div className="svgContainer flex center">
              <img src="/web-2/assets/images/purple-circle-check.svg?v=rb" alt="peerspace" />
            </div>

            <span>
              <FormattedMessage id="invite.attendee_footer.book_few_clicks" defaultMessage="Book in just a few clicks" />
            </span>
          </div>
        </div>

        <div className="flex center" onClick={redirUserToHomepage} data-testing-id="explore-spaces-link">
          <a className="btn btn-default">
            <FormattedMessage id="invite.attendee_footer.explore_spaces" defaultMessage="Explore Spaces" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default AttendeeFooter;
